import { useMessages } from "../language/language"
import { serverPlayJoin } from "utils/server"
import { hasText } from "utils/helpers"
import LoginComponent from "../components/login-component"
import { serverRequestErrorReducer, studentJoinedReducer } from "play/reducers"
import { usePlayState } from "play/hooks/use-play-state"
import { useEffect, useRef } from "react"

function UsernamePage() {
  const msg = useMessages()
  const { gameCode, fullName, modifyState } = usePlayState()
  const isLoading = useRef(false)

  function handleFullNameChanged(text: string) {
    modifyState((state) => {
      state.fullName = text
    })
  }

  function handleStartClicked() {
    console.log("handleStartClicked")
    if (!hasText(gameCode) || isLoading.current) {
      return
    }
    isLoading.current = true

    modifyState(async (state) => {
      try {
        console.log("before serverPlayJoin")
        const resp = await serverPlayJoin({ gameCode, fullName })
        modifyState((state) => {
          isLoading.current = false
          studentJoinedReducer(state, resp)
        })
      } catch (e) {
        console.log("after serverPlayJoin")
        modifyState((state) => {
          isLoading.current = false
          serverRequestErrorReducer(state, e)
        })
      }
    })
  }

  useEffect(() => {
    modifyState((state) => {
      state.serverError = null
      state.joinError = null
      state.serverErrorData = null
    })
  }, [])

  return (
    <LoginComponent
      type="login"
      label={msg.usernamePage_instructions}
      value={fullName || ""}
      actionButtonText={msg.usernamePage_action}
      inputSize="big"
      isEnabled={!isLoading.current}
      onInputChanged={handleFullNameChanged}
      onActionClicked={handleStartClicked}
    />
  )
}

export default UsernamePage
